<template>
  <IconLucideMonitorPlay />
</template>
